// Tipos para o sistema de turnos do RPG

export interface Player {
  id: string;
  name: string;
  avatar?: string;
  isNpc?: boolean;        // Indica se é um NPC
  characterId?: string;   // ID do personagem (para NPCs)
  className?: string;     // Classe do personagem (ex: Warrior, Mage)
  // Presença na mesa AGORA (socket vivo). Ausente para NPC, que não tem
  // presença. É o que decide quem já vem marcado ao abrir a rodada: aluno que
  // faltou entrava na fila e a turma esperava os dois minutos dele.
  online?: boolean;
}

export interface TurnState {
  // Estado do sistema de turnos
  isActive: boolean;
  isPaused: boolean; // Turno preparado mas não iniciado (aguardando "Iniciar Turno")
  
  // Informações do turno atual
  currentPlayerId: string | null;
  playerOrder: string[]; // Array com IDs dos jogadores na ordem do turno
  
  // Controle de tempo
  timeRemaining: number; // Tempo em segundos
  totalTime: number; // Tempo total configurado para cada turno
  
  // Controle de permissões
  masterId: string; // ID do mestre da mesa
  
  // Metadados
  turnNumber: number; // Número do turno atual
  startedAt: Date | null; // Quando o turno atual começou
}

export interface TurnAction {
  // Ações que podem ser enviadas via WebSocket
  type: 'turn_start' | 'turn_next' | 'turn_adjust_time' | 'turn_end' | 'turn_update';
  payload: {
    tableId: string;
    masterId: string;
    playerOrder?: string[];
    timeAdjustment?: number; // Para +30s ou -30s
    totalTime?: number; // Para configurar tempo total do turno
  };
}

export interface TurnControlProps {
  // Props para componentes que controlam turnos
  turnState: TurnState;
  players: Player[];
  currentUserId: string;
  isMaster: boolean;
  
  // Funções de controle (apenas para mestre)
  onStartTurn: (playerOrder: string[], totalTime: number) => void;
  onNextPlayer: () => void;
  onAdjustTime: (seconds: number) => void;
  onEndTurn: () => void;
}

export interface TurnDisplayProps {
  // Props para componentes que apenas exibem estado do turno
  turnState: TurnState;
  players: Player[];
  currentUserId: string;
}

export interface TurnPermissions {
  // Permissões derivadas do estado do turno
  canSendMessage: boolean;
  canControlTurn: boolean;
  isMyTurn: boolean;
  isMaster: boolean;
}

// Estado inicial padrão
export const defaultTurnState: TurnState = {
  isActive: false,
  isPaused: false,
  currentPlayerId: null,
  playerOrder: [],
  timeRemaining: 0,
  totalTime: 180, // 3 minutos por padrão
  masterId: '',
  turnNumber: 0,
  startedAt: null,
};

// Configurações de tempo pré-definidas
export const TURN_TIME_PRESETS = {
  short: 120, // 2 minutos
  medium: 180, // 3 minutos
  long: 300, // 5 minutos
  extended: 600, // 10 minutos
} as const;

export type TurnTimePreset = keyof typeof TURN_TIME_PRESETS;

// Eventos WebSocket para turnos
export interface TurnWebSocketMessage {
  type: 'turn_state_updated';
  data: TurnState;
}